import { Alert, StatusType } from '@platform/witems';
import {
  claimEvidenceOf, claimRecheckOf, CLAIM_NOTE, type CallRead, type ClaimEvidence,
} from '../logic/claimEvidence';
import { useClinicCallTasks } from '../state/data/task';

type ClaimTask = NonNullable<Parameters<typeof claimEvidenceOf>[0]> & { withings_user_id?: unknown };

function ClaimEvidenceBody({ ev, uid }: { ev: ClaimEvidence; uid: string | null }) {
  const calls = useClinicCallTasks(uid, { enabled: ev.callIds.length > 0 });
  let read: CallRead = 'loading';
  if (calls.isError) read = 'error';
  else if (calls.data) read = calls.data;
  const recheck = claimRecheckOf(ev, read);
  const details = [...ev.details, recheck.note, CLAIM_NOTE].filter(Boolean).join(' · ');
  return (
    <div style={{
      margin: '8px 0 0', display: 'flex', flexDirection: 'column', gap: 8,
    }}
    >
      {recheck.warning && <Alert type={StatusType.MODERATE} text={recheck.warning} />}
      {ev.summary && <Alert type={StatusType.INFO} text={ev.summary} />}
      <span className="detail1 text-secondary">{details}</span>
    </div>
  );
}

// Mounted on BOTH task surfaces (drawer + patient-file card): the coordinator's check on the claim is the
// control, so it must see what the month rests on, and what changed since, wherever the task is opened.
export default function ClaimEvidenceStatus({ task }: { task: ClaimTask | null | undefined }) {
  const ev = claimEvidenceOf(task);
  if (!ev) return null;
  return <ClaimEvidenceBody ev={ev} uid={task?.withings_user_id == null ? null : String(task.withings_user_id)} />;
}
